// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.patient.patientportaluser.PatientPortalAuthenticationRequest */
/* istanbul ignore next */
@GandalfModel
export class PatientPortalAuthenticationRequest extends GandalfModelBase {

	@GandalfLabel('Allow Login')
	@GandalfValidator({ notNull: { message: 'Allow Login is required' } })
	@GandalfProperty({ designType: Boolean, isRequired: true })
	allowLogin!: boolean;

	@GandalfLabel('Authorized Patients')
	@GandalfValidator({ notNull: { message: 'Authorized Patients is required' } })
	@GandalfArray(Number)
	authorizedPatientIds!: number[];

	@GandalfLabel('Patient')
	@GandalfValidator({ notNull: { message: 'Patient is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	patientId!: number;

}
